exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feedback[data-v-22d0749a]{padding:20px}.search_criteria[data-v-22d0749a]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.search_criteria>div[data-v-22d0749a]{margin:6px 5px;width:180px;height:40px;border:1px solid #efefef}.w100[data-v-22d0749a]{width:100%}.h[data-v-22d0749a]{height:100%}.page_box[data-v-22d0749a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.page_box[data-v-22d0749a]  .el-pagination__jump{margin-left:0px}", ""]);

// exports
